import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CalendarDomain } from '../@shared/interfaces/calendar.interfaces';
import { useCalendarManagement } from './useCalendarManagement';

export const useCalendarOAuthRedirect = (
  userId?: string,
  redirectPath: string = '/settings?tab=accounts'
) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [handled, setHandled] = useState(false);
  const { connectCalendar } = useCalendarManagement();

  useEffect(() => {
    if (handled || !userId) return;

    const code = searchParams.get('code');
    const stateParam = searchParams.get('state');

    if (!code) return;

    // Determine calendar domain from state parameter
    let domain = CalendarDomain.GOOGLE; // Default to Google
    if (stateParam === CalendarDomain.OUTLOOK) {
      domain = CalendarDomain.OUTLOOK;
    }

    setHandled(true);

    connectCalendar.mutate(
      { code, domain },
      {
        onSettled: () => {
          // Redirect regardless of success/error (error handling in hook)
          navigate(redirectPath);
        },
      }
    );
  }, [searchParams, handled, userId, connectCalendar, navigate, redirectPath]);

  return { isHandling: connectCalendar.isPending };
};
